import { useHttp } from '@/request';
import { useCoudanInfoStore } from '../coudanInfoStore';
import { reportCatchError } from '@/utils/reportCatchError';

const updateOldItemsWithNewItems = (newItems, oldItems) => {
    const oldItemsById = new Map(oldItems.map(item => [item.itemId, item]));

    newItems.forEach(newItem => {
        if (oldItemsById.has(newItem.itemId)) {
            const oldItem = oldItemsById.get(newItem.itemId);

            const updatedSkus = oldItem?.skus?.map(sku => {
                if (sku.skuId === newItem.skuId) {
                    return {
                        ...sku,
                        ...{
                            salePrice: newItem.salePrice,
                            displaySalePrice: newItem.displaySalePrice,
                            activityPrice: newItem.activityPrice,
                            displayActivityPrice: newItem.displayActivityPrice,
                            discountRate: newItem.discountRate,
                        },
                    };
                }
                return sku;
            });

            oldItem.skus = updatedSkus || [];
        }
    });

    return [...oldItemsById.values()];
};

// https://kapi.corp.kuaishou.com/mock/12929/rest/o/ecom/customer/item/makeup/bar

export function useMakeUpApi() {
    const { extraInfo } = useCoudanInfoStore(s => ({
        extraInfo: s.extraInfo,
    }));
    const setCoudanStore = useCoudanInfoStore().setState;
    const getCoudanStore = useCoudanInfoStore().getState;
    const { data, loading, runAsync } = useHttp('POST/rest/o/ecom/product/customer/item/makeup/bar', null, { manual: true });

    async function makeUpItems(selectProducts, address, encryptedParam, itemId, scene) {
        try {
            const res = await runAsync({
                body: {
                    version: extraInfo?.version ?? 1,
                    selectProducts: selectProducts,
                    address: address,
                    encryptedParam: encryptedParam,
                    itemId: itemId,
                    scene: scene,
                },
            });
            // 增量更新凑单楼层中的商品信息
            const oldRecoItems = getCoudanStore().recoItems;
            const newRecoItems = updateOldItemsWithNewItems(res.data?.makeUpSkuPriceInfo, JSON.parse(JSON.stringify(oldRecoItems)));
            setCoudanStore({
                recoItems: newRecoItems,
                checkOutDetail: res?.data?.checkOutDetail,
                discountTip: res?.data?.discountTip,
                extraInfo: res?.data?.extra,
                thresholdStage: res?.data?.thresholdStage || {},
            });
        } catch (error) {}
    }
    return {
        loading,
        makeUpItems,
    };
}

export function useGetCoudanInfoApi(params: { itemId: number | string; encryptedParam: any; scene: number | string }) {
    const { loading, runAsync: loadCoudanInfo } = useHttp('GET/rest/o/ecom/product/customer/item/reco/makeup/info', null, { manual: true });

    const setCoudanStore = useCoudanInfoStore().setState;
    const fetchCoudanData = () => {
        loadCoudanInfo({
            query: params,
        })
            .then(res => {
                const recoItemsForFe = res?.data?.recoItems?.map(item => {
                    item.skus = item.skus.map(skuItem => {
                        return { ...skuItem, skuQuantity: item?.extra.quantity };
                    });
                    return item;
                });
                setCoudanStore({
                    coudanRawData: res?.data,
                    recoItems: recoItemsForFe,
                    shopRecoItems: res?.data?.shopRecoItems || [],
                    checkOutDetail: res?.data?.checkOutDetail,
                    discountTip: res?.data?.discountTip,
                    extraInfo: res?.data?.extra,
                    thresholdStage: res?.data?.thresholdStage,
                    sameItems: res?.data?.sameItems,
                });
            })
            .catch(reportCatchError);
    };

    return {
        fetchCoudanData,
        loading,
    };
}

// {
//     "merchantId": 1234, //商家id
//     "mediaId": 0, //  商详盖楼 动态取值
//     "mediaSource": 30, // 商详盖楼来源 写死
//     "selected": [
//         {
//             "itemId": 1234, //itemId
//             "skuId": 123456, // skuId
//             "num": 1 //购买数量
//         },
//         {
//             "itemId": 1234, //itemId
//             "skuId": 123456, // skuId
//             "num": 1 //购买数量
//         }
//     ]
// }

// 返回值
// {
// 	"result": 1,
// 	"message": "成功",
// 	"data": {
// 		"count": 3, // 成功加购的sku数量
// 		"addFailType": 2  // 1加购成功toast   2 部分商品由于信息变更加购失败toast
// 	},
// 	"extra": null,
// 	"extraInfo": null,
// 	"host": "public-xm-c-kce-node119.idchb1az1.hb1.kwaidc.com",
// 	"port": 22314,
// 	"timestamp": [2023, 10, 8, 14, 30, 1, 795193000]
// }
export function useAddCartItemFromCommercialFloorApi() {
    const { data, loading, runAsync } = useHttp('POST/rest/o/ecommerce/customer/shopCart/addCartItemFromCommercialFloor', null, { manual: true });

    async function addCartItemFromCommercialFloor(merchantId, mediaId, selected) {
        try {
            const res = await runAsync({
                body: { merchantId: merchantId, selected: selected },
            });
            return res;
        } catch (error) {
            console.log(error);
        }
    }
    return {
        loading,
        addCartItemFromCommercialFloor,
    };
}
